import { type ProductDetailsPageState } from "~/features/productDetails/redux/productDetailsTypes";
import { PDP_SELECT_PRICE_REFERENCE, type PdpActions } from "~/features/productDetails/redux/actions";
import {
  FINISH_RESOLVING_ACCORDION_PRODUCT_EMPTY,
  FINISH_RESOLVING_ACCORDION_PRODUCT_SUCCESS,
  type PdpAccordionActions,
  START_RESOLVING_ACCORDION_PRODUCT,
} from "~/features/productDetails/redux/pdpProductAccordionActions";
import { type Reducer } from "redux";

export const initialProductDetailsPageState: ProductDetailsPageState = {
  selectedPriceReference: "",
  accordionLoading: false,
  accordionProductCode: "",
  accordionType: null,
};

export const productDetailsPageReducer: Reducer<ProductDetailsPageState, PdpAccordionActions | PdpActions> = (
  state = initialProductDetailsPageState,
  action,
): ProductDetailsPageState => {
  switch (action.type) {
    case PDP_SELECT_PRICE_REFERENCE: {
      return {
        ...state,
        selectedPriceReference: action.payload,
      };
    }
    case START_RESOLVING_ACCORDION_PRODUCT: {
      return {
        ...state,
        accordionLoading: true,
      };
    }
    case FINISH_RESOLVING_ACCORDION_PRODUCT_SUCCESS: {
      const { productCode, type } = action.payload;
      return {
        ...state,
        accordionLoading: false,
        accordionProductCode: productCode,
        accordionType: type,
      };
    }
    case FINISH_RESOLVING_ACCORDION_PRODUCT_EMPTY: {
      return {
        ...state,
        accordionLoading: false,
        accordionProductCode: "",
        accordionType: null,
      };
    }

    default: {
      return state;
    }
  }
};
